"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooterButtons = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var SpinnerButton_1 = require("components/SpinnerButton");
var ModalFooterButtons = function (_a) {
    var showDisconnect = _a.showDisconnect, identifier = _a.identifier, handleIdentifierRequest = _a.handleIdentifierRequest, closeModal = _a.closeModal, currentStatus = _a.currentStatus, handleDisconnect = _a.handleDisconnect;
    return (React.createElement(React.Fragment, null,
        showDisconnect && (React.createElement(sok_ui_1.Button, { color: "red", onClick: handleDisconnect }, (0, translation_1.getLocalization)('modal/disconnect'))),
        React.createElement(SpinnerButton_1.SpinnerButton, { color: "green", isButtonDisabled: !identifier, handleOnClick: function () { return handleIdentifierRequest(identifier); }, buttonText: (0, translation_1.getLocalization)('modal/save'), shouldDisplaySpinner: currentStatus === 'BUSY' }),
        React.createElement(sok_ui_1.Button, { color: "dark-gray", onClick: closeModal }, (0, translation_1.getLocalization)('modal/cancel'))));
};
exports.ModalFooterButtons = ModalFooterButtons;
